import React from 'react'

const Separate = () => {
  return (
    <div className='separate'>
        
    </div>
  )
}

export default Separate